import { Page, View, Text } from "@react-pdf/renderer";

import { Props } from "../../ClearOrderDocument";
import { styles } from "../styles";
import { AdditionalInformation } from "./AdditionalInformation";
import { Options } from "./Options";
import { PatientSection } from "./PatientSection";
import { ProceduresSection } from "./ProceduresSection";
import { Signature } from "./Signature";

export function MedicareDocument({
  name,
  activeAbnNotice,
  accountNumber,
}: Props) {
  return (
    <Page size="LETTER" style={styles.page}>
      <View style={styles.content} wrap>
        <View style={styles.section}>
          <PatientSection name={name} accountNumber={accountNumber} />
          <View
            style={{
              height: 3,
              backgroundColor: "black",
              marginTop: 10,
              marginBottom: 2,
            }}
          />
          <Text style={{ ...styles.title, fontSize: 14, marginTop: 2 }}>
            Advance Beneficiary Notice of Non-coverage (ABN)
          </Text>
          <ProceduresSection activeAbnNotice={activeAbnNotice} />
          {activeAbnNotice && <Options activeAbnNotice={activeAbnNotice} />}
          <AdditionalInformation />
          <Signature activeAbnNotice={activeAbnNotice} />
        </View>
      </View>
    </Page>
  );
}
